import * as React from "react"
export const ToolbarCamera = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
     viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fill="#6C757D"
      d="M19.086 5.114a1.642 1.642 0 0 0-1.731.157.848.848 0 0 0-.092.08L15.8 6.828C15.623 4.691 13.85 3 11.667 3h-7.5A4.17 4.17 0 0 0 0 7.166v5a4.171 4.171 0 0 0 4.167 4.166h7.5c2.19 0 3.973-1.705 4.135-3.855l1.463 1.461a.978.978 0 0 0 .09.077 1.646 1.646 0 0 0 1.73.156c.565-.282.915-.85.915-1.478V6.594c0-.63-.35-1.198-.914-1.48Zm-7.42 9.552h-7.5a2.503 2.503 0 0 1-2.5-2.5v-5c0-1.379 1.122-2.5 2.5-2.5h7.5c1.379 0 2.5 1.121 2.5 2.5v5c0 1.378-1.121 2.5-2.5 2.5Zm4.167-4.514V9.16l2.5-2.523.021 6.031-2.52-2.518Z"
    />
  </svg>
)

